import { gql } from 'graphql-tag';

export const getDigitalThemesQuery = gql`
  query themeOptions($page: Int, $perPages: Int) {
    themes(page: $page, per_page: $perPages) {
      id
      name
      digital_preview_image_url
    }
  }
`;

export const getPrintThemesQuery = gql`
  query themeOptions($page: Int, $perPages: Int) {
    template_book_pairs(page: $page, per_page: $perPages) {
      id
      preview_image_url
      template_book {
        id
        name
      }
      spread_template_book {
        id
        name
      }
    }
  }
`;
export const getThemeDefaultQuery = gql`
  query getThemeDefault($bookId: ID!) {
    book(id: $bookId) {
      id
      print_theme_id
      digital_theme_id
    }
  }
`;

export const getDigitalThemeByIdQuery = gql`
  query getThemeById($themeId: ID!) {
    theme(id: $themeId) {
      id
      name
      digital_preview_image_url
    }
  }
`;

export const getPrintThemeByIdQuery = gql`
  query getThemeById($themeId: ID!) {
    template_book_pair(id: $themeId) {
      id
      preview_image_url
      template_book {
        id
        name
      }
      spread_template_book {
        id
        name
      }
    }
  }
`;
